import { useAppDispatch } from "hooks/hooks";
import { setCalculationPopoverOpen } from "../scenes/payroll/payroll.slice";
import {
  selectState as employeeSelectState,
  setNewEmployeePopover,
  setSearchPopoverOpen,
  setGetEmployeesParams,
} from "../scenes/employee/employeeSlice";
import { selectState as payrollSelectState } from "../scenes/payroll/payroll.slice";
import SearchEmployeePopover from "../scenes/employee/components/SearchEmployeePopover";
import CalculationPrintModal from "../scenes/payroll/components/CalculationPrintModal";
import { useEffect, useRef, useState } from "react";
import PrintAdmin from "../scenes/payroll/components/PrintAdmin";
import { useSelector } from "react-redux";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { useNavigate } from "react-router-dom";
import { hrService } from "../services/hr.services";
import { IPayrollSummary } from "../domain/IPayrollSummary";
import Popover from "components/Popover/Popover";
import NewEmployeePopover from "../scenes/employee/components/NewEmployeePopover";
import CalculateAllPayrollsPopover from "../scenes/payroll/components/CalculateAllPayrollsPopover";
import { useForm } from "react-hook-form";
import { ICreateEmployeeRequestParams } from "../domain/ICreateEmployeeRequestParams";
import { SalaryType } from "../domain/SalaryType";
import { IGetAllEmployeesRequestParams } from "../domain/IGetAllEmployeesRequestParams";
import { selectState as selectStateAuth } from "authentication/main.slice";
import { hasWriteAccessTo } from "utils/authUtil";
import { HUMAN_RESOURCES_MODULE_NAME } from "../domain/HumanResourcesModule";
import { usePagePrint } from "hooks/usePagePrint";
import { areQueryParamsEmpty } from "utils/queryParamsUtil";
import { GetLastYears } from "utils/dateUtils";

const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(selectStateAuth);
  const { newEmployeePopover, searchPopoverOpen }
    = useSelector(employeeSelectState);
  const {
    calculationPrintModalOpen,
    calculationAllPayrollsConfirmationOpen,
    calculationPopoverOpen
  } = useSelector(payrollSelectState);

  const [statsShow,] = useState<boolean>(false);

  const componentRefAdmin = useRef<HTMLDivElement>(null);

  const handlePrintAdmin = usePagePrint(componentRefAdmin,
    { margins: "0" });

  const [, setTotals] = useState<IPayrollSummary>();

  const [month,] = useState<number | null>(null);
  const [year,] = useState<number | null>(null);
  const [payrollMonth, setPayrollMonth] = useState(new Date().getMonth());
  const payrollAvailableYears = GetLastYears(2);
  const [payrollYear, setPayrollYear] = useState(payrollAvailableYears[0]);

  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
    reset,
    setFocus,
    getValues,
    setValue
  } = useForm<ICreateEmployeeRequestParams>();

  const [employeeRoleValue, setEmployeeRoleValue]
    = useState<number | undefined>(undefined);
  const [salaryType, setSalaryType] = useState(SalaryType.HOURLY);

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    control: controlSearch,
    reset: resetSearch,
    setFocus: setFocusSearch,
    getValues: getValuesSearch,
    setValue: setValueSearch
  } = useForm<IGetAllEmployeesRequestParams>();

  const isSearchFormEmpty = areQueryParamsEmpty(getValuesSearch());

  useEffect(() => {
    if (month && year) {
      hrService.getPayrollSummaryForEmployee({ year, month }).then((totals) => {
        setTotals(totals);
      });
    }
  }, [month, year, statsShow]);

  return (
    <>
      <nav className="container">
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            tooltip="Glavni meni"
            toolbox={true}
            onClick={() => navigate('/dashboard')}
          />
        </div>
        <div>
          <ToolboxButton
            icon={ToolboxButtonIcon.Add}
            tooltip="Novi"
            toolbox={true}
            onClick={hasWriteAccessTo(user, HUMAN_RESOURCES_MODULE_NAME)
              ? () => dispatch(setNewEmployeePopover({ isOpen: true }))
              : undefined}
          />
          <ToolboxButton
            icon={ToolboxButtonIcon.Search}
            tooltip="Traži"
            toolbox={true}
            onClick={() => dispatch(setSearchPopoverOpen({ isOpen: true }))}
          />
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => {
                dispatch(setGetEmployeesParams({}));
                resetSearch();
              }}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.DateRange}
            tooltip="Obračun plata"
            toolbox={true}
            onClick={hasWriteAccessTo(user, HUMAN_RESOURCES_MODULE_NAME)
              ? () => dispatch(setCalculationPopoverOpen({ isOpen: true }))
              : undefined}
          />
        </div>
      </nav>
      <Popover
        isOpen={newEmployeePopover.isOpen}
        onClose={() => dispatch(setNewEmployeePopover({ isOpen: false }))}
        title="Dodavanje novog radnika"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 185 }}
      >
        <NewEmployeePopover
          handleSubmit={handleSubmit}
          register={register}
          control={control}
          errors={errors}
          reset={reset}
          employeeRoleValue={employeeRoleValue}
          setEmployeeRoleValue={setEmployeeRoleValue}
          salaryTypeValue={salaryType}
          setSalaryTypeValue={setSalaryType}
          setFocus={setFocus}
          getValues={getValues}
          setValue={setValue}
        />
      </Popover>
      { }
      <Popover
        isOpen={calculationPopoverOpen.isOpen}
        onClose={() => {
          if (!calculationAllPayrollsConfirmationOpen) {
            dispatch(setCalculationPopoverOpen({ isOpen: false }));
          }
        }}
        title="Obračun plata"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 310 }}
      >
        <CalculateAllPayrollsPopover
          availableYears={payrollAvailableYears}
          year={payrollYear}
          month={payrollMonth}
          setMonth={setPayrollMonth}
          setYear={setPayrollYear}
        />
      </Popover>
      <Popover
        isOpen={searchPopoverOpen.isOpen}
        onClose={() => dispatch(setSearchPopoverOpen({ isOpen: false }))}
        title="Pretraga"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 250 }}
      >
        <SearchEmployeePopover
          handleSubmit={handleSubmitSearch}
          register={registerSearch}
          control={controlSearch}
          getValues={getValuesSearch}
          setValue={setValueSearch}
          setFocus={setFocusSearch}
        />
      </Popover>
      {calculationPrintModalOpen && (
        <CalculationPrintModal
          handlePrintAdmin={handlePrintAdmin}
          selectedMonth={payrollMonth}
          selectedYear={payrollYear}
        />
      )}
      <div ref={componentRefAdmin} className="print-area">
        <PrintAdmin />
      </div>

    </>

  );
};

export default Toolbox;
